import { render, staticRenderFns } from "./AdvertGroupRela.vue?vue&type=template&id=3e3e31eb&scoped=true"
import script from "./AdvertGroupRela.vue?vue&type=script&lang=js"
export * from "./AdvertGroupRela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e31eb",
  null
  
)

export default component.exports